import React, { useState, lazy, Suspense, useEffect, useMemo } from 'react'
import { Row, Col, Skeleton } from 'antd'
import { useQuery } from '@apollo/client'

import { Link, Switch, Route, useRouteMatch } from 'react-router-dom'
import { CalendarWrapper } from './style'
import { ShareButtonPageHeader } from '../../../components/buttons/share-button/share-button'
import { ExportButtonPageHeader } from '../../../components/buttons/export-button/export-button'
import { CalendarButtonPageHeader } from '../../../components/buttons/calendar-button/calendar-button'
import { Main } from '../../styled'
import { Button } from '../../../components/buttons/buttons'
import { Cards } from '../../../components/cards/frame/cards-frame'
import { PageHeader } from '../../../components/page-headers/page-headers'
import 'react-calendar/dist/Calendar.css'
import { Tabs } from 'antd'

import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'
import { PanelFiltrov } from '../../../components/filtre/panelFiltrov'
import { useZdrzanie } from '../../../utils/zdrzanie'

import { useTranslation } from 'react-i18next'
import moment from 'moment'
import {
  GET_DEVICES_BY_BRANCHOFFICE_ID,
  GET_RESERVATIONS_SEARCH
} from '../../../graphql/AdminQueries'
const WeekCalendar = lazy(() => import('./overview/Week'))
// import { Tab } from './overview/tabs/tabs'

const { TabPane } = Tabs

const Calendars = () => {
  const { t } = useTranslation('common')

  const graphqlVariables = {
    tokenGet: process.env.REACT_APP_TOKEN_GET,
    branchOffice:
      Number(Cookies.get('selectedCompany')) ||
      Number(Cookies.get('branchOfficeId'))
  }
  const branchOffices = useQuery(GET_DEVICES_BY_BRANCHOFFICE_ID, {
    variables: graphqlVariables
  })
  let branchOfficesData = []
  const [deviceId, setDeviceId] = useState(1)
  let data = []
  if (branchOffices?.data?.getDevicesByBranchOfficeId) {
    branchOfficesData = branchOffices?.data?.getDevicesByBranchOfficeId
    data.push({
      title: t('backend.reservations.device1'),
      tabTitle: t('backend.reservations.device1'),
      deviceId: branchOfficesData[0].id
    })
    if (branchOfficesData.length === 2) {
      data.push({
        title: t('backend.reservations.device2'),
        tabTitle: t('backend.reservations.device2'),
        deviceId: branchOfficesData[1].id
      })
    }
  }

  useEffect(() => {
    if (branchOfficesData && branchOfficesData[0]) {
      setDeviceId(branchOfficesData[0].id)
    }
  }, [branchOfficesData])
  const onChange = key => {
    setDeviceId(key)
  }

  // FILTRE KALENDARA (21.9.2026).
  // Drzia sa TU, nad zalozkami zariadeni, nie vnutri kalendara. Antd necha
  // navstivenu zalozku namontovanu, takze bezia dve instancie kalendara a
  // kazda by mala vlastne filtre, ktore by sa po prepnuti rozisli.
  const rezervacie = useSelector(state => state?.reservation?.allReservations)

  const PRAZDNE_FILTRE = {
    majitelId: undefined,
    najomcaId: undefined,
    pickup: undefined,
    maPoznamku: undefined,
    sezonaSkladu: undefined
  }
  const [filtre, setFiltre] = useState(PRAZDNE_FILTRE)
  const [hladanie, setHladanie] = useState('')
  // Datum, na ktory ma kalendar skocit po kliknuti na vysledok hladania.
  // `nonce` je tam preto, aby sa druhe kliknutie na ten isty datum tiez
  // prejavilo, napriklad ked clovek medzitym prelistoval inam.
  const [skokNaDatum, setSkokNaDatum] = useState(null)
  // Kalendar prepocitava cely tyzden nad vsetkymi rezervaciami pobocky,
  // takze sa filtruje az ked clovek prestane pisat.
  const hladanieZdrzane = useZdrzanie(hladanie, 300)

  // Firmy sa vyberaju podla id, nie podla nazvu: v ciselniku je 15 majitelov
  // s rovnakym nazvom a filter podla textu by ich zlepil do jedneho.
  const firmyDoVyberu = vyber => {
    const najdene = new Map()
    ;(Array.isArray(rezervacie) ? rezervacie : []).forEach(r => {
      const firma = vyber(r)
      if (firma?.id && String(firma?.company || '').trim() !== '') {
        najdene.set(Number(firma.id), String(firma.company).trim())
      }
    })
    const zoznam = Array.from(najdene.entries())
      .map(([hodnota, popis]) => ({ hodnota, popis }))
      .sort((a, b) => a.popis.localeCompare(b.popis, 'sk'))
    // Rezervacie bez firmy sa inak nedaju vybrat a pri filtrovani ticho zmiznu.
    zoznam.unshift({ hodnota: 0, popis: 'bez firmy' })
    return zoznam
  }

  // Roletky sa prepocitavaju len pri zmene rezervacii. Predtym sa pri kazdom
  // prekresleni kalendara prechadzali vsetky rezervacie pobocky dvakrat.
  const majitelia = useMemo(
    () => firmyDoVyberu(r => r?.car?.carOwner),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rezervacie]
  )
  const najomcovia = useMemo(
    () => firmyDoVyberu(r => r?.car?.carRenter),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rezervacie]
  )

  // HLADANIE V CELOM ARCHIVE (14.10.2026).
  // Kalendar ma v pamati len zobrazeny tyzden, takze filter nad nim nikdy
  // nenajde auto objednane na iny mesiac. Preto sa hlada na serveri a nad
  // kalendarom sa ukaze zoznam najdenych terminov s datumom.
  const hladaneOrezane = String(hladanieZdrzane || '').trim()
  // Zamerne bez minima znakov, rovnako ako hladanie v zoznamoch: jedna dvojka
  // musi najst vsetko, co dvojku obsahuje. Pri takom sirokom dopyte server
  // vrati 300 najnovsich a zoznam to oznaci plusom, takze to nic nezhodi.
  const hladameNaServeri = hladaneOrezane !== ''
  const vysledkyHladania = useQuery(GET_RESERVATIONS_SEARCH, {
    variables: {
      tokenGet: graphqlVariables.tokenGet,
      branchOfficeId: graphqlVariables.branchOffice,
      search: hladaneOrezane,
      limit: 300
    },
    skip: !hladameNaServeri || !graphqlVariables.branchOffice,
    fetchPolicy: 'cache-and-network'
  })

  // Zdvihaky sa cisluju podla poradia zo servera, rovnako ako zalozky nizsie.
  const menoZdvihaka = useMemo(() => {
    const mapa = {}
    ;(branchOfficesData || []).forEach((z, poradie) => {
      mapa[String(z.id)] = t(`backend.reservations.device${poradie + 1}`)
    })
    return mapa
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchOfficesData])

  const najdeneTerminy = useMemo(() => {
    const zoznam = vysledkyHladania?.data?.getReservations || []
    // Server radi od najnovsieho. Pre obsluhu je uzitocnejsie mat najblizsi
    // buduci termin hore, minulost az pod nim.
    const dnes = moment().startOf('day')
    const buduce = []
    const minule = []
    zoznam.forEach(r => {
      const d = moment(r?.date)
      ;(d.isBefore(dnes, 'day') ? minule : buduce).push(r)
    })
    buduce.sort((a, b) => moment(a?.date).diff(moment(b?.date)))
    minule.sort((a, b) => moment(b?.date).diff(moment(a?.date)))
    return buduce.concat(minule)
  }, [vysledkyHladania])

  const definicieFiltrov = useMemo(
    () => [
    {
      kluc: 'hladanie',
      popis: 'Hľadať',
      typ: 'text',
      sirka: 4,
      zastupnyText: 'EČV, vodič, uskladnenie'
    },
    {
      kluc: 'majitelId',
      popis: 'Majiteľ',
      typ: 'vyber',
      sirka: 5,
      moznosti: majitelia
    },
    {
      kluc: 'najomcaId',
      popis: 'Nájomca',
      typ: 'vyber',
      sirka: 5,
      moznosti: najomcovia
    },
    {
      kluc: 'pickup',
      popis: 'Pickup',
      typ: 'vyber',
      sirka: 3,
      moznosti: [
        { hodnota: 'ano', popis: 'áno' },
        { hodnota: 'nie', popis: 'nie' }
      ]
    },
    {
      kluc: 'maPoznamku',
      popis: 'S poznámkou',
      typ: 'vyber',
      sirka: 3,
      moznosti: [
        { hodnota: 'ano', popis: 'áno' },
        { hodnota: 'nie', popis: 'nie' }
      ]
    },
    {
      kluc: 'sezonaSkladu',
      popis: 'Uskladnená sezóna',
      typ: 'vyber',
      sirka: 4,
      moznosti: [
        { hodnota: 'ZIMA', popis: 'ZIMA' },
        { hodnota: 'LETO', popis: 'LETO' }
      ]
    }
    ],
    [majitelia, najomcovia]
  )

  return (
    <>
      <PageHeader ghost title={t('backend.reservations.title')} />
      <Main>
        <CalendarWrapper className='reservation-overview'>
          <Row gutter={25}>
            <Col xxl={24} xl={15} xs={24}>
              <PanelFiltrov
                filtre={definicieFiltrov}
                hodnoty={{ ...filtre, hladanie }}
                onZmena={(kluc, hodnota) => {
                  if (kluc === 'hladanie') {
                    setHladanie(hodnota || '')
                    return
                  }
                  setFiltre(predosle => ({ ...predosle, [kluc]: hodnota }))
                }}
                onVycistit={() => {
                  setFiltre(PRAZDNE_FILTRE)
                  setHladanie('')
                }}
              />
              <div
                style={{
                  margin: '-8px 0 16px',
                  fontSize: 12,
                  color: '#868eae'
                }}
              >
                Hľadanie prehľadá celý archív pobočky a nájdené termíny ukáže
                nižšie. Ostatné filtre platia na zobrazený týždeň.
              </div>

              {hladameNaServeri && (
                <Cards
                  title={
                    vysledkyHladania?.loading && !najdeneTerminy.length
                      ? 'Hľadám v celom archíve'
                      : `Nájdené termíny (${najdeneTerminy.length}${
                          najdeneTerminy.length >= 300 ? '+' : ''
                        })`
                  }
                  size='small'
                >
                  {vysledkyHladania?.error && (
                    <div style={{ color: '#ff4d4f' }}>
                      Hľadanie zlyhalo: {vysledkyHladania.error.message}
                    </div>
                  )}

                  {!vysledkyHladania?.error &&
                    !vysledkyHladania?.loading &&
                    !najdeneTerminy.length && (
                      <div style={{ color: '#868eae' }}>
                        Na "{hladaneOrezane}" nesedí žiadna rezervácia v celom
                        archíve tejto pobočky.
                      </div>
                    )}

                  {najdeneTerminy.length > 0 && (
                    <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                      {najdeneTerminy.map(r => {
                        const auto = r?.car
                        const firma =
                          auto?.carRenter?.company || auto?.carOwner?.company
                        const vodic = [
                          auto?.driver_firstname,
                          auto?.driver_lastname
                        ]
                          .filter(Boolean)
                          .join(' ')
                        return (
                          <div
                            key={r.id}
                            onClick={() => {
                              // Zalozka sa prepne len ak pre ten zdvihak
                              // naozaj existuje. Inak by activeKey ukazoval na
                              // nic a kalendar by zostal prazdny.
                              const idZdvihaka = String(r?.device?.id || '')
                              if (
                                idZdvihaka &&
                                data.some(
                                  z => String(z.deviceId) === idZdvihaka
                                )
                              ) {
                                setDeviceId(idZdvihaka)
                              }
                              setSkokNaDatum({
                                datum: moment(r?.date).format('YYYY-MM-DD'),
                                nonce: Date.now()
                              })
                            }}
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              gap: 12,
                              alignItems: 'baseline',
                              padding: '7px 4px',
                              borderBottom: '1px solid #f4f5f7'
                            }}
                          >
                            <div
                              style={{
                                flex: '0 0 150px',
                                fontWeight: 600,
                                color: r?.pickup ? '#cf1322' : '#272b41'
                              }}
                            >
                              {moment(r?.date).format('D.M.YYYY')}{' '}
                              {String(r?.from_time || '').slice(0, 5)}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontWeight: 600 }}>
                                {auto?.licence_plate || 'bez EČV'}
                                {r?.pickup ? ', PICKUP' : ''}
                              </div>
                              <div style={{ fontSize: 12, color: '#868eae' }}>
                                {[auto?.type, vodic, firma]
                                  .filter(Boolean)
                                  .join(', ')}
                                {r?.note ? `, ${r.note}` : ''}
                              </div>
                            </div>
                            <div
                              style={{
                                flex: '0 0 auto',
                                fontSize: 12,
                                color: '#5a5f7d'
                              }}
                            >
                              {menoZdvihaka[String(r?.device?.id)] || ''}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </Cards>
              )}
              <Switch>
                <Suspense
                  fallback={
                    <Cards headless>
                      <Skeleton paragraph={{ rows: 15 }} active />
                    </Cards>
                  }
                >
                  <Tabs
                    activeKey={String(deviceId)}
                    onChange={onChange}
                  >
                    {data.map(item => {
                      const { title } = item
                      return (
                        <TabPane tab={title} key={String(item.deviceId)}>
                          <WeekCalendar
                            selectedDeviceId={deviceId}
                            filtreKalendara={filtre}
                            hladanieKalendara={hladanieZdrzane}
                            skokNaDatum={skokNaDatum}
                            zdvihaky={data}
                          />
                        </TabPane>
                      )
                    })}
                  </Tabs>
                </Suspense>
              </Switch>
            </Col>
          </Row>
        </CalendarWrapper>
      </Main>
    </>
  )
}

export default Calendars
